module.exports = __webpack_public_path__ + "static/media/ag.e89d2587.jpeg";